import rootReducer from './index';
import { createAppStore } from './utils';
const store = createAppStore(rootReducer);
export default store;